import React from 'react';
import PropTypes from 'prop-types';

import { Card, TitleCard, SubTitleCard, HeaderCard, ContentCard } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './swapSeatMapCard.module.css';
import SwapSeatMap from './swapSeatMap';
import { SeatMapLegend } from '../../../placement/throne-seat-elements';
import useSeatedContext from '../../../../context/seatedContext';

export default function SwapSeatMapCard({
    attendees = [],
    availability = null,
    onAvailability = null,
    popover = null,
    onSeatOver = () => {},
    onSeatsSelected = () => {},
    onClose = () => {}
}) {
    const { t } = useTranslation();
    const [{ inventory }] = useSeatedContext();

    return (
        <Card className={Style['swap-seat-map-card']}>
            <HeaderCard separator={false}>
                <TitleCard title={t('ticket.swapSeat.title')} />
                <SubTitleCard title={t('ticket.swapSeat.subtitle')} />
            </HeaderCard>
            <ContentCard>
                <SwapSeatMap
                    zone={{ uuid: attendees.length ? attendees[0].attendee.booking.seat_zone : null }}
                    selectedAttendees={attendees}
                    availability={availability}
                    onAvailability={onAvailability}
                    popover={popover}
                    onSeatOver={onSeatOver}
                    onSeatsSelected={onSeatsSelected}
                    onClose={onClose}
                />
                {availability?.seats?.length > 0 && <SeatMapLegend seats={availability?.seats} isSocialDistancing={inventory.isSocialDistancing()} />}
            </ContentCard>
        </Card>
    );
}

SwapSeatMapCard.propTypes = {
    attendees: PropTypes.array,
    availability: PropTypes.object,
    onAvailability: PropTypes.func,
    onClose: PropTypes.func,
    popover: PropTypes.node,
    onSeatOver: PropTypes.func,
    onSeatsSelected: PropTypes.func
};
